import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CalculationReferenceDate {
	asOfDate: string;
}

@Injectable({ providedIn: 'root' })
export class CalculationReferenceDateService {
	private readonly http = inject(HttpClient);
	private readonly endpoint = `${environment.apiUrl}/Calculations/reference-date`;

	getReferenceDate(): Observable<CalculationReferenceDate> {
		return this.http.get<CalculationReferenceDate>(this.endpoint);
	}
}

export function formatReferenceDate(value: string): string | null {
	const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
	if (!match) return null;

	const year = Number(match[1]);
	const month = Number(match[2]);
	const day = Number(match[3]);
	const date = new Date(Date.UTC(year, month - 1, day));
	if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;

	return new Intl.DateTimeFormat('en-GB', {
		day: '2-digit',
		month: 'short',
		year: 'numeric',
		timeZone: 'UTC'
	}).format(date);
}
